<template>
          <div id="nav">
            <div class="collapse-handle">
                <img style="height:30px; width:30px " src="../assets/images/logo1.png" alt />
            </div>
            <el-menu
                    default-active="1"
                    class="el-menu-vertical-demo"
                    background-color="#333333"
                    text-color="#ffffff"
                    active-text-color="#409eff"
                    :collapse="isCollapse"
            >
                <template v-for="(item,index) in navList">
                    <el-menu-item
                            :index="item.index"
                            :key="item.name"
                            v-if="!item.isHide && item.type === 1"
                            @click="gotoLink(item.link,item.type)"
                    >
                        <!-- <em :class="item.icon" :style="(item.isActive?'color: #409eff;':'color: #ffffff;')" style="font-size: 20px;" ></em> -->
                        <em :class="item.icon"></em>
                        <span slot="title" >{{item.name}}</span>

                    </el-menu-item>
                  <el-menu-item
                      index="3"
                      :key="index"
                      v-if="!item.isHide && item.type ===2 && (roles ==='1' || roles ==='4')"
                      @click="gotocustomer(item.type)"
                  >
                    <em :class="item.icon"></em>
                    <span slot="title">{{item.name}}</span>

                  </el-menu-item>
                </template>
            </el-menu>

            <div class="help-document" @mouseenter="enterClick">
                <el-tooltip  class="help-item" effect="dark"   placement="right" v-model="orderLength">
                  <div slot="content">
                    <span v-if="showContent">上传下载中心</span>
                    <span v-if="showContentToop">导出任务已提交，请前往<span @click="gotoDownLoad" style="padding: 0 4px;color: #409eff;cursor: pointer">下载中心</span>查看进度</span>
                    <span v-if="deriveScreen">导入任务已提交，请前往<span @click="goUpLoad" style="padding: 0 4px;color: #409eff;cursor: pointer">上传中心</span>查看进度</span>
                  </div>
                    <el-link type="primary" class="help-link" :underline="false" @click="gotoDownLoad()">
                        <em
                            class="arsenal_icon arsenalxiazai"
                            :style="(IsActive?'color: #409eff;':'color: #ffffff;')"
                            style="font-size: 26px;"
                        ></em>
                    </el-link>
                </el-tooltip>
            </div>
            <div class="user-handle">
                <div id="user-info">
                    <el-dropdown @command="topHandleCommand">
                        <span class="el-dropdown-link">
                            <span class="head_portrait">
                                <img src="../assets/images/UserImage.png" style="width: 25px;height: 25px;">
                            </span>
                        </span>
                        <el-dropdown-menu slot="dropdown" style="min-width:150px;">
                          <el-dropdown-item   style="color: black;word-break: break-word;border-bottom: 2px solid #f5f8fb;line-height: 30px">{{userInfo.username}}</el-dropdown-item>
                            <el-dropdown-item command="profile" class="borderBottom"><i class="el-icon-user-solid" ></i>个人信息</el-dropdown-item>
                          <el-dropdown-item command="business" class="borderBottom" v-if="roles === '1' || roles === '6'"><i class="el-icon-office-building"></i>企业管理</el-dropdown-item>
                          <el-dropdown-item command="change" class="borderBottom" v-if="roles === '1' || roles === '4'"><i class="arsenal_icon arsenalzhuanjie" ></i>切换系统</el-dropdown-item>
                            <el-dropdown-item command="logout" style="line-height: 40px"><i class="el-icon-switch-button" style="font-size: 16px;padding-right: 10px;color: #409eff"></i>退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>

</template>

<script>
let that
import {requestUrl} from "@/api/requestUrl";

export default {
        name: "test",
        data(){
            return {
                testDrawerVisibleP: false,
                testDrawerVisibleS:false,
                isCollapse: false,
              userInfo: {},
                IsActive: false,
                navList: [
                    {
                        type: 1,
                        name: "首页",
                        link: "/workorderinfo",
                        index: "1",
                        icon: "arsenal_icon arsenalhome1",
                        isHide: false,
                        isActive: false,
                        image:require('../assets/images/order.png'),


                    },
                    {
                        type: 1,
                        name: "工单管理",
                        link: "/workorderinfo",
                        index: "1",
                        icon: "arsenal_icon arsenalfunnel-dollar-solid",
                        isHide: false,
                        isActive: false,
                        image:require('../assets/images/order.png'),


                    },
                    {
                        type: 1,
                        name: "客户中心",
                        index: "2",
                        link: "/customerInfo",
                        icon: "arsenal_icon arsenalkehu",
                        isHide: false,
                        isActive: false,
                        image:require('../assets/images/customer.png'),

                    },
                  {
                    type: 2,
                    name: "客服工作台",
                    index: "3",
                    link: "kefu",
                    icon: "arsenal_icon arsenalkefu",
                    isHide: false,
                    isActive: false,
                    image:require('../assets/images/customer.png'),
                  },
                  {
                    type: 1,
                    name: "设置",
                    index: "4",
                    link: "/fieldmanagement",
                    icon: "arsenal_icon arsenalshezhi",
                    isHide: false,
                    isActive: false,
                    image:require('../assets/images/customer.png'),
                  }
                   /* {
                        type: 1,
                        name: "设置",
                        index: "3",
                        link: "fieldmanagement",
                        icon: "arsenal_icon arsenalshezhi",
                        isHide: false,
                        isActive: false
                    },*/
                    /*{
                        type: 1,
                        name: "对话记录",
                        index: "4",
                        link: "dialogues",
                        icon: "arsenal_icon arsenalcomment-solid",
                        isHide: false,
                        isActive: false
                    },
                    {
                        type: 1,
                        name: "统计分析",
                        index: "5",
                        link: "statistics",
                        icon: "arsenal_icon arsenalzhandianshujutongji",
                        isHide: false,
                        isActive: false
                    },
                    {
                        type: 1,
                        name: "成员管理",
                        index: "6",
                        link: "accountManage",
                        icon: "arsenal_icon arsenalyonghuguanli",
                        isHide: false,
                        isActive: false
                    }*/
                ],
                roles:'',
              tooltipContent:'上传下载中心',
              orderLength:false,
              showContent:false,
              showContentToop:false,
              deriveScreen:false,
                testtttt:false
            };
        },
        props:{
          checkOrder:Number,
          deriveScreenCheck:Number
        },
        watch: {
            "$route.path": function(to) {
                this.showIsActive(to);
                console.log(to)
            },
            //添加CNZZ统计
            $route: {
                handler() {
                    setTimeout(() => {
                        //避免首次获取不到window._czc
                        if (window._czc) {
                            let location = window.location;
                            let contentUrl = location.pathname + location.hash;
                            let refererUrl = "/";
                            // 用于发送某个URL的PV统计请求，
                            window._czc.push(["_trackPageview", contentUrl, refererUrl]);
                        }
                    }, 300);
                },
                immediate: true // 首次进入页面即执行
            },
          checkOrder:{
              handler(){
                this.orderLength=true
                this.showContent=false
                this.showContentToop=true
                  setTimeout(()=>{
                      this.showContentToop=false
                      let cla=document.getElementsByClassName('is-dark')
                      cla[cla.length-1].style.display='none'
                      console.log(cla)
                  },5000)
                this. deriveScreen=false

              },
            deep:true
          },
          deriveScreenCheck:{
            handler(){
              this.orderLength=true
              this.showContent=false
              this.showContentToop=false
              this. deriveScreen=true
                setTimeout(()=>{
                    this.deriveScreen=false
                    let cla=document.getElementsByClassName('is-dark')
                    cla[cla.length-1].style.display='none'
                },5000)

            },
            deep:true
          }
        },
        methods: {
          enterClick(){
            this.tooltipContent='上传下载中心'
            this.showContent=true
            this.showContentToop=false
            this.deriveScreen=false
              let cla=document.getElementsByClassName('is-dark')
              cla[cla.length].style.display='block'
          },
            topHandleCommand(command) {
                console.log("======command:",command)
                if (command === "logout") {
                    this.$http.delete("/api/sso/auth/sign-out").then(res => {
                        console.log("=======signout result:",res);
                        if (res.status === 200) {
                            this.$router.push({
                                name: "CheckAuth"
                            });
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                }
              if(command === 'profile')
              {
                this.$router.push({path:'personal'})
                this.$set(this.navList[0], `isActive`, false);
                this.$set(this.navList[1], `isActive`, false);
                this.$set(this.navList[2], `isActive`, false);
                this.$set(this.navList[3], `isActive`, false);
                this.IsActive = false;
              }
              if(command === 'business')
              {
                let windo= window.open('_blank')
                console.log(requestUrl[process.env.NODE_ENV].portal)
                windo.location = requestUrl[process.env.NODE_ENV].portal;
                windo.location = requestUrl[process.env.NODE_ENV].test;
              }
              if(command === 'change')
              {
                console.log(requestUrl[process.env.NODE_ENV].portal)
                 window.open(requestUrl[process.env.NODE_ENV].portal)
               /* windo.location = requestUrl[process.env.NODE_ENV].portal;*/
              }
            },
            gotoLink(link) {
                this.$router.push(link);
            },
          gotocustomer(type){
            if(type == 2)
            {
              /*window.location='https://test.im.askbot.cn'*/
              let windo= window.open('_blank')
              windo.location = requestUrl[process.env.NODE_ENV].im;
            }
          },
            showIsActive(to) {
              console.log(to)
                if(to==='/workorderinfo'||to==='/customerInfo'||to==='/fieldmanagement')
                {
                    this.$set(this.navList[0], `isActive`, true);
                    this.$set(this.navList[1], `isActive`, false);
                    this.$set(this.navList[2], `isActive`, false);
                  this.$set(this.navList[3], `isActive`, false);
                    this.IsActive = false;
                }
                if(to==='/customerInfo')
                {
                    this.$set(this.navList[0], `isActive`, false);
                    this.$set(this.navList[1], `isActive`, true);
                    this.$set(this.navList[2], `isActive`, false);
                  this.$set(this.navList[3], `isActive`, false);
                    this.IsActive = false;
                }
                if(to==='/fieldmanagement')
                {
                    this.$set(this.navList[0], `isActive`, false);
                    this.$set(this.navList[1], `isActive`, false);
                    this.$set(this.navList[2], `isActive`, false);
                    this.$set(this.navList[3], `isActive`, true);
                    this.IsActive = false;
                }
                if(to ==='/downLoad' || to==='/upLoad' || to ==='/download')
                {
                  this.$set(this.navList[0], `isActive`, false);
                  this.$set(this.navList[1], `isActive`, false);
                  this.$set(this.navList[2], `isActive`, false);
                  this.$set(this.navList[3], `isActive`, false);
                  this.IsActive = true;
                }
                /*   if (
                    to === "/workorderinfo" ||
                    to === "/cusomlist" ||
                    to === "/fieldmanagement" ||
                    to === "/main/chatFlow" ||
                    to === "/main/statistics" ||
                    to === "/main/accountManage"
                ) {
                    this.$set(this.navList[1], `isActive`, false);
                    this.$set(this.navList[2], `isActive`, false);
                    this.$set(this.navList[3], `isActive`, false);
                    this.$set(this.navList[0], `isActive`, true);
                    this.$set(this.navList[4], `isActive`, false);
                    this.$set(this.navList[5], `isActive`, false);
                }*/
                /*if (to === "/main/entityManage") {
                    this.helpIsActive = false;
                    this.$set(this.navList[0], `isActive`, false);
                    this.$set(this.navList[2], `isActive`, false);
                    this.$set(this.navList[3], `isActive`, false);
                    this.$set(this.navList[1], `isActive`, true);
                    this.$set(this.navList[4], `isActive`, false);
                    this.$set(this.navList[5], `isActive`, false);
                }
                if (to === "/main/trainList") {
                    this.helpIsActive = false;
                    this.$set(this.navList[0], `isActive`, false);
                    this.$set(this.navList[1], `isActive`, false);
                    this.$set(this.navList[3], `isActive`, false);
                    this.$set(this.navList[2], `isActive`, true);
                    this.$set(this.navList[4], `isActive`, false);
                    this.$set(this.navList[5], `isActive`, false);
                }
                if (to === "/main/statistics") {
                    this.helpIsActive = false;
                    this.$set(this.navList[0], `isActive`, false);
                    this.$set(this.navList[1], `isActive`, false);
                    this.$set(this.navList[2], `isActive`, false);
                    this.$set(this.navList[3], `isActive`, false);
                    this.$set(this.navList[4], `isActive`, true);
                    this.$set(this.navList[5], `isActive`, false);
                }
                if (to === "/main/dialogues") {
                    this.helpIsActive = false;
                    this.$set(this.navList[0], `isActive`, false);
                    this.$set(this.navList[1], `isActive`, false);
                    this.$set(this.navList[2], `isActive`, false);
                    this.$set(this.navList[3], `isActive`, true);
                    this.$set(this.navList[4], `isActive`, false);
                    this.$set(this.navList[5], `isActive`, false);
                }
                if (to === "/main/accountManage") {
                    this.helpIsActive = false;
                    this.$set(this.navList[0], `isActive`, false);
                    this.$set(this.navList[1], `isActive`, false);
                    this.$set(this.navList[2], `isActive`, false);
                    this.$set(this.navList[3], `isActive`, false);
                    this.$set(this.navList[4], `isActive`, false);
                    this.$set(this.navList[5], `isActive`, true);
                }
                if (to === "/main/help") {
                    this.$set(this.navList[0], `isActive`, false);
                    this.$set(this.navList[1], `isActive`, false);
                    this.$set(this.navList[2], `isActive`, false);
                    this.$set(this.navList[3], `isActive`, false);
                    this.$set(this.navList[4], `isActive`, false);
                    this.$set(this.navList[5], `isActive`, false);
                    this.helpIsActive = true;
                }*/
            },
            // 跳转到下载中心页面
            gotoDownLoad() {
                this.$router.push({ path: "downLoad" });
            },
          goUpLoad(){
            this.$router.push({ path: "upLoad" });
          },
            handleOpen() {
                // this.isCollapse = true;
            },
            handleClose() {
                // this.isCollapse = false;
            },
            // 展示测试窗
            showTest() {
                this.testDrawerVisibleP = true;
                //this.$refs.Statistics.setTestOpen(true);

            },
            changeTestContentVisible(value) {
                console.log(value);
                this.$eventBus.$emit('test-window-visible',value);
                this.testDrawerVisibleP = value;
            },
            //获取用户角色
          getRole(){
            /*this.$http.get('/api/account/current').then(res=>{
              if(res.data.code==='0')
              {
                this.userInfo=res.data.data
                console.log(this.userInfo)
                if(this.userInfo.roles[0]!==null)
                {
                  this.roles=this.userInfo.roles[0]
                }
              }
            })*/
            this.roles =localStorage.getItem('roleId')
            if(this.roles !=='1' && this.roles !=='4')
            {
              for (let i=0;i<this.navList.length;i++)
              {
                if(this.navList[i].type ===2)
                  this.navList[i].isHide=true
              }
            }
            let uid=localStorage.getItem('_uid')
            this.$http.get('/portal-api/account/appoint/'+uid).then(res=>{
              console.log(res)

              if(res.data.code==='0')
              {
                this.userInfo=res.data.data
              }
            })
          }
        },
      beforeCreate() {
          that=this
      },
      created() {
        that.getRole()
      },
      mounted() {

        console.log( this.check)
            var to = this.$route.path;
            this.showIsActive(to);
            // 创建cnzz统计js
            const script = document.createElement("script");
            script.src = `https://s95.cnzz.com/z_stat.php?id=${1278715588}&web_id=${1278715588}`;
            script.language = "JavaScript";
            document.body.appendChild(script);
            console.log(localStorage.getItem('_uid'))

            // window.__be = window.__be || {};
            // window.__be.id = "194";
            // window.__be.apiKey = "9014a0474db54debbc4a0fc2d8416840";
            // window.__be.secret = "4e5445784e5467354e6a49304f44517a4f544d34";
            // (function() {
            //     var be = document.createElement("script");
            //     be.type = "text/javascript";
            //     be.async = true;
            //     be.src = "https://open.guoranbot.com/ref.js";
            //     var s = document.getElementsByTagName("script")[0];
            //     s.parentNode.insertBefore(be, s);
            // })();
        }
    }
</script>

<style scoped lang="less">
    @import "../assets/less/main/common";
    .borderBottom{
      border-bottom: 2px solid #f5f8fb;
      line-height: 40px;
      i{
        color: #409eff;
        font-size: 16px;
        padding-right: 10px;
      }
    }
    #nav {
        min-width: 64px !important;
        height: 100vh;
        background-color: rgb(51, 51, 51);
        padding: 0;
        margin: 0;
        overflow: hidden;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;

    .collapse-handle {
        flex: none;
        color: whitesmoke;
        height: 55px;
        text-align: center;
        line-height: 55px;
        background-color: @system_fontcolor_red;

    img {
        margin-top: 10px;
    }

    em {
        cursor: pointer;
        font-size: 20px
    }
    }

    .help-document {
        text-align: center;
    .help-link {
        font-size: 20px;
        color: #ffffff;
        margin-bottom: 25px;

    }
    }

    .user-handle {
        flex: none;
        height: 48px;
        text-align: center;

    #user-info {
        height: 48px;
        flex: none;
        line-height: 48px;

    .head_portrait {
        display: inline-block;
        overflow: hidden;
        color: #ffffff;
        font-size: 30px;
        height: 30px;
        line-height: 30px;
    //border-radius: 15px;
    //background-color: white;
        text-align: center;
        cursor: pointer;

    }

    .user_handle {
        text-align: center;
        cursor: pointer;

    .el-dropdown {
        width: 64px;
    }

    .el-dropdown-link {
        color: white;
    }
    }
    }
    }

    .el-menu {
        flex: auto;
        border: none !important;
    }

    .el-menu-vertical-demo:not(.el-menu--collapse) {
        height: 400px;
        width: 150px;
        text-align: left;

    ul {
    li {
        text-indent: 13px;
    }
    }
    }
    }
    .item.icon{
       font-size: 28px;
        font-weight: bold;
    }
    .el-menu-item{
      display: flex !important;
      flex-direction: row !important;
      align-items: center !important;
      height: 56px !important;
      line-height: 56px !important;
      em{
        font-size: 18px !important;
      }
    }
</style>